// Small date helpers shared by the task list, board and task panel.

// The API returns naive UTC datetimes ("2026-10-27T16:00:00"); treat those as UTC, not local.
export const parseDue = (v) => {
  if (!v) return null;
  if (v instanceof Date) return v;
  const s = String(v);
  const d = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(s) || s.length <= 10 ? s : `${s}Z`);
  return Number.isNaN(d.getTime()) ? null : d;
};

const pad = (n) => String(n).padStart(2, '0');
export const ymd = (d) => (d ? `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` : '');

// A due date picked as a day is stored as local noon, so it never slips a day across time zones.
export const dayToISO = (day) => {
  if (!day) return null;
  const [y, m, dd] = day.split('-').map(Number);
  return new Date(y, m - 1, dd, 12, 0, 0).toISOString();
};

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
export const daysFromToday = (d) => Math.round((startOfDay(d) - startOfDay(new Date())) / 86400000);

export const GROUPS = [
  { id: 'overdue', label: 'Overdue' },
  { id: 'today', label: 'Today' },
  { id: 'tomorrow', label: 'Tomorrow' },
  { id: 'week', label: 'Next 7 days' },
  { id: 'later', label: 'Later' },
  { id: 'none', label: 'No date' },
];

export const groupFor = (task) => {
  const d = parseDue(task.due_date);
  if (!d) return 'none';
  const n = daysFromToday(d);
  if (n < 0) return 'overdue';
  if (n === 0) return 'today';
  if (n === 1) return 'tomorrow';
  if (n <= 7) return 'week';
  return 'later';
};

export const dueLabel = (v) => {
  const d = parseDue(v);
  if (!d) return '';
  const n = daysFromToday(d);
  if (n === 0) return 'Today';
  if (n === 1) return 'Tomorrow';
  if (n === -1) return 'Yesterday';
  if (n > 1 && n < 7) return d.toLocaleDateString('en-CA', { weekday: 'short' });
  return d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric', ...(d.getFullYear() !== new Date().getFullYear() ? { year: 'numeric' } : {}) });
};

export const initials = (s) => (s || '').split(/[\s@.]+/).filter(Boolean).slice(0, 2).map((x) => x[0].toUpperCase()).join('');
